import { render, staticRenderFns } from "./DataEnabledTextInput.vue?vue&type=template&id=2aaba5b5"
import script from "./DataEnabledTextInput.vue?vue&type=script&lang=js"
export * from "./DataEnabledTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports